export type TUser = {
  userId: number;
  points: number;
  doors: { status: boolean; id: number }[];
};

export type TUserState = { user: TUser | null; status: EUserStatus };

export enum EUserStatus {
  Init = 'init',
  Loading = 'loading',
  Success = 'success',
  Failed = 'failed',
}

export type TDoors = {
  first: { status: boolean; id: number };
  second: { status: boolean; id: number };
  third: { status: boolean; id: number };
  fourth: { status: boolean; id: number };
  fifth: { status: boolean; id: number };
  sixth: { status: boolean; id: number };
  seventh: { status: boolean; id: number };
  eighth: { status: boolean; id: number };
};
